import { render } from "./Home.vue?vue&type=template&id=1ae54f04"
const script = {}
script.render = render

export default script